import React from 'react';
import api from '../lib/api';

const defaultFieldClass =
  'w-full px-4 py-2.5 rounded-xl border border-slate-200 bg-white text-slate-900 focus:border-emerald-500 focus:ring-2 focus:ring-emerald-200 outline-none';

/**
 * Campos de cadastro rápido de um local que ainda não é cliente (prospecto).
 */
const LocalAvulsoCampos = ({
  value = {},
  onChange,
  fieldClass = defaultFieldClass,
  compact = false,
}) => {
  const update = (field, next) => {
    onChange?.({ ...value, [field]: next });
  };

  return (
    <div className={compact ? 'space-y-3' : 'space-y-4'}>
      <div>
        <label className="block text-sm font-medium text-slate-700 mb-1.5">
          Nome do local
        </label>
        <input
          type="text"
          value={value.nome || ''}
          onChange={(e) => update('nome', e.target.value)}
          placeholder="Ex.: Metalúrgica São João"
          className={fieldClass}
          data-testid="avulso-nome-input"
        />
      </div>
      <div>
        <label className="block text-sm font-medium text-slate-700 mb-1.5">
          Endereço
        </label>
        <input
          type="text"
          value={value.endereco || ''}
          onChange={(e) => update('endereco', e.target.value)}
          placeholder="Rua, número, bairro"
          className={fieldClass}
          data-testid="avulso-endereco-input"
        />
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
        <div className="sm:col-span-2">
          <label className="block text-sm font-medium text-slate-700 mb-1.5">
            Cidade
          </label>
          <input
            type="text"
            value={value.cidade || ''}
            onChange={(e) => update('cidade', e.target.value)}
            placeholder="Ex.: Campinas"
            className={fieldClass}
            data-testid="avulso-cidade-input"
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-slate-700 mb-1.5">
            UF
          </label>
          <input
            type="text"
            value={value.estado || ''}
            onChange={(e) => update('estado', e.target.value.toUpperCase().slice(0, 2))}
            placeholder="SP"
            maxLength={2}
            className={fieldClass}
            data-testid="avulso-estado-input"
          />
        </div>
      </div>
      <div className="max-w-xs">
        <label className="block text-sm font-medium text-slate-700 mb-1.5">
          CEP <span className="font-normal text-slate-400">(opcional)</span>
        </label>
        <input
          type="text"
          inputMode="numeric"
          value={value.cep || ''}
          onChange={(e) => update('cep', e.target.value.replace(/\D/g, '').slice(0, 8))}
          placeholder="13000000"
          className={fieldClass}
          data-testid="avulso-cep-input"
        />
      </div>
    </div>
  );
};

export const avulsoVazio = () => ({
  nome: '',
  endereco: '',
  cidade: '',
  estado: '',
  cep: '',
});

export const avulsoPreenchido = (dados) =>
  Boolean((dados?.nome || '').trim() && (dados?.endereco || '').trim());

export async function cadastrarLocalAvulso(dados) {
  const { data } = await api.post('/clientes/avulso', {
    nome: (dados.nome || '').trim(),
    endereco: (dados.endereco || '').trim(),
    cidade: (dados.cidade || '').trim(),
    estado: (dados.estado || '').trim(),
    cep: (dados.cep || '').trim(),
  });
  return data;
}

export default LocalAvulsoCampos;
